import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { ExportModel, ExportPayload } from 'common/models/export.model';
import { WidgetType } from '../../models/widget.model';
import { isEqual } from '../../components/widgets/utils';

// identifier
export const EXPORT_SLICE_ID = 'export';

// default state
const initialState: ExportModel = {};

//slice
const exportSlice = createSlice({
  name: EXPORT_SLICE_ID,
  initialState,
  reducers: {
    setExportData: (state: ExportModel, action: PayloadAction<ExportPayload>): void => {
      const { id, data } = action.payload;
      if (!state[id]) {
        state[id] = {};
      }

      const img = state[id]?.image;
      const nextState = {
        ...data,
        image: img,
      };
      if (!isEqual(state[id], nextState)) {
        state[id] = nextState; // mutate if not the same
      }
    },
    extendExportData: (state: ExportModel, action: PayloadAction<ExportPayload>): void => {
      const { id, data } = action.payload;
      if (!state[id]) {
        state[id] = {};
      }
      state[id] = {
        ...(state[id] ? state[id] : {}),
        ...{
          response: {
            ...(id && state[id] ? (state[id] as any).response : {}),
            ...data,
          },
        },
      };
    },
    resetExportData: (state: ExportModel): void => {
      Object.assign(state, {});
    },
    removeExportDataForWidget: (
      state: ExportModel,
      action: PayloadAction<Partial<ExportPayload>>
    ): void => {
      if (action.payload.id) {
        state[action.payload.id] = null;
        delete state[action.payload.id];
      }
    },
  },
});

//selectors

export const selectExportData = (state: RootState) => state.export;

export const selectExportDataById = (state: RootState, id: string) =>
  state.export[id] ? state.export[id] : null;

export const selectExportByWidgetType = createSelector(
  [(state: RootState) => state.export, (state: RootState, type: WidgetType) => type],
  (pptData, type) => {
    const widgets = Object.keys(pptData).filter((key) => {
      const data = pptData[key];
      if (data?.widget && data.widget.type === type) {
        return true;
      }
      return false;
    });
    return widgets.length > 0 ? widgets.map((key) => pptData[key]) : [];
  }
);

//actions
export const { setExportData, extendExportData, resetExportData, removeExportDataForWidget } =
  exportSlice.actions;

//reducer
export default exportSlice;
